import type { User } from 'features/auth';
import {
  isCesGroupSuperVisor,
  isEngagementSpecialist,
  isGroupsAdmin,
  isMaintainer,
  isMedicalGroupAdmin,
} from 'permissions/user-roles';
import { isCommunitiesAdmin, isOrganizationsAdmin, isProgramsAdmin } from '../utils';

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion -- We need assertion to boolean, there was problem with radnom null
export const isSuperAdmin = ({ viewer }: { viewer: User }) => Boolean(viewer.railsUserData.superadmin);

export const isAdmin = ({ viewer }: { viewer: User }) =>
  isSuperAdmin({ viewer }) ||
  isOrganizationsAdmin({ viewer: viewer.railsUserData }) ||
  isCommunitiesAdmin({ viewer: viewer.railsUserData }) ||
  isProgramsAdmin({ viewer: viewer.railsUserData }) ||
  isGroupsAdmin({ viewer: viewer.railsUserData }) ||
  isMedicalGroupAdmin({ nodeViewer: viewer.nodeUserData }) ||
  isCesGroupSuperVisor({ nodeViewer: viewer.nodeUserData }) ||
  isEngagementSpecialist({ viewer: viewer.railsUserData });

export const canViewAdminDashboard = ({ viewer }: { viewer: User }) =>
  isAdmin({ viewer }) || isMaintainer({ viewer: viewer.railsUserData });
